module.exports = __webpack_public_path__ + "close-icon.c30463a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close-icon.png
// module id = kbsO
// module chunks = 0